// extracted by mini-css-extract-plugin
export var collapsedSummary = "_p0-0";